import React, { ReactNode, useContext, useEffect } from 'react';

import { IStaticPageRoute } from 'remote/queries/static-page';
import { useCRMEventsContext } from 'state/crm-events';

import { useStaticPageRoutes } from './hooks/use-static-page-routes';

export interface IStaticPageContext {
  routes: IStaticPageRoute[];
  routesLoading: boolean;
}

export const PageManagerContext = React.createContext<IStaticPageContext>({} as IStaticPageContext);
export const usePageManagerContext = () => useContext(PageManagerContext);

export function PageManagerProvider({ children }: { children: ReactNode }) {
  const { routes, loading: routesLoading } = useStaticPageRoutes();
  const { updateStaticRoutes } = useCRMEventsContext();

  // Updates static routes in mParticle to log when users visit static pages
  useEffect(() => {
    updateStaticRoutes(routes);
  }, [routes, updateStaticRoutes]);

  return (
    <PageManagerContext.Provider
      value={{
        routes,
        routesLoading,
      }}
    >
      {children}
    </PageManagerContext.Provider>
  );
}

export default PageManagerContext.Consumer;
